import { useMediaQuery } from "@mui/material";

function AsarButton({
  color = "var(--emr-primary)",
  onClick,
  disabled = false,
  children,
  style = undefined,
}) {
  const md = useMediaQuery("(max-width:450px)");
  const defaultStyle = {
    display: "flex",
    padding: md ? "6px 12px" : "12px 24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    width: md ? "calc(min(100%, 300px))" : "calc(min(100%, 400px))",
    borderRadius: "8px",
    background: color,
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
    border: "none",
    color: "white",
    fontSize: "16px",
    cursor: "pointer",
  };
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type="button"
      style={!style ? defaultStyle : { ...defaultStyle, ...style }}
    >
      {children}
    </button>
  );
}

export default AsarButton;
